// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"4313":"9d51a78103887e9d","6599":"b34cc5aa499db836"}[chunkId] + ".css";
};